import { FC } from 'react';

import { ListItem } from '../ListItem';
import { NBSP } from '../../../../constants/symbols';
import { TG_URL } from '../../constants';
import { FormWrapper } from '../FormWrapper';
import { EActiveConsultationModal } from '../../../../types/redux/states';
import {
  IconCommunicationEmail16,
  IconCommunicationPhone16,
  IconSocialTelegram16,
} from '@cian/ui-kit-design-tokens/icons';

interface IChoosingTypeConsultation {
  setActiveModal: (step: EActiveConsultationModal) => void;
  tgUrl: string;
}
export const ChoosingTypeConsultation: FC<IChoosingTypeConsultation> = ({ setActiveModal }) => {
  const onRedirect = () => {
    window.location.href = TG_URL;
  };

  return (
    <FormWrapper
      title="Как хотите проконсультироваться?"
      subtitle={`Ответим на все вопросы с 09:00 до 18:00 по${NBSP}будням`}
    >
      <div>
        <ListItem
          title="По телефону"
          icon={<IconCommunicationPhone16 color="icon-secondary-default" />}
          handleClick={() => setActiveModal(EActiveConsultationModal.PhoneForm)}
        />
        <ListItem
          title="В персональном чате Telegram"
          icon={<IconSocialTelegram16 color="icon-secondary-default" />}
          handleClick={onRedirect}
        />
        <ListItem
          title="По электронной почте"
          icon={<IconCommunicationEmail16 color="icon-secondary-default" />}
          handleClick={() => setActiveModal(EActiveConsultationModal.EmailForm)}
        />
      </div>
    </FormWrapper>
  );
};
